import { Component, Input, OnInit } from '@angular/core';

/**
 * Component that displays [text] in a string, replacing all http and https urls with anchor tags
 */
@Component({
	selector: 'auto-link',
	//don't add any extra whitespace, user-entered text expected to display line breaks and spaces
	template: '<ng-container *ngFor="let segment of segments">{{segment.text}}<a *ngIf="segment.url" target="_blank" [href]="segment.url">{{segment.url}}</a></ng-container>',
	standalone: false
})
export class AutoLinkComponent implements OnInit {
	@Input() public text: string;
	public segments: Array<{ text: string, url?: string }> = [];

	public ngOnInit(): void {
		const regex = (/https?:\/\/[^'"\s]+/g);

		this.segments = [];
		let i = 0;
		for(const match of this.text.matchAll(regex)) {
			const url = match[0];
			this.segments.push({
				text: this.text.substring(i, match.index),
				url
			});
			i = match.index + url.length;
		}

		const tail = this.text.substring(i);
		if(tail) {
			this.segments.push({ text: tail });
		}
	}
}
